/**
 * Internal Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuSearch } from '@neutron/react';

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin-right: 1rem;
`;

export const SearchInput = styled(NeuSearch)<{ width?: number }>`
  padding: 0px 6px 0px 6px;
  position: static;
  width: ${props => (props.width ? `${props.width}px` : '375px')} !important;
  --form-gap: 3px;
  > label {
    width: 100% !important;
    height: auto !important;
  }
`;
